import { useMemo } from 'react'
import { useRefreshInfo } from 'hooks/useUiState/index'
import { WidgetId } from 'features/types'

const useRefreshTimestamp = (widgetId?: WidgetId) => {
  const refreshInfo = useRefreshInfo()

  const refreshTimestamp = useMemo(() => {
    const { onDemands } = refreshInfo
    const onDemandRefreshTimeStamp = onDemands[widgetId!]

    return widgetId ? onDemandRefreshTimeStamp || refreshInfo.timestamp : refreshInfo.timestamp
  }, [refreshInfo, widgetId])

  return refreshTimestamp
}

export default useRefreshTimestamp
